/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
  list: {
    fontSize: 12,
  },
}));

const WifiSetup = () => {
  const classes = useStyles();
  return (
    <div>
      <h4 className={classes.title}> Follow the instructions below and click CONTINUE.</h4>
      <ol className={classes.list}>
        <li>From the menu, select Control &#8594; Macro</li>
        <li>
          In the file explorer, find and select the file you just edited, "Neuralert-Wifi-script-&lt;deviceId&gt;.ttl"
        </li>
        <li>Wait a moment for the script to finish running</li>
      </ol>
    </div>
  );
};

export default WifiSetup;
